import React from "react";

export function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <div className="border-b border-slate-200 bg-white px-8 py-6" data-testid="page-header">
      <div className="flex items-end justify-between gap-6 flex-wrap">
        <div>
          {eyebrow && <div className="section-eyebrow mb-1">/// {eyebrow}</div>}
          <h1 className="font-display text-3xl font-black tracking-tighter text-slate-900">{title}</h1>
          {subtitle && <p className="text-sm text-slate-600 mt-1 max-w-2xl">{subtitle}</p>}
        </div>
        {children && <div className="flex items-center gap-3">{children}</div>}
      </div>
    </div>
  );
}

export function StatCard({ label, value, sub, icon: Icon, tone = "default", testid }) {
  const tones = {
    default: "text-slate-900",
    success: "text-green-700",
    warning: "text-amber-700",
    danger: "text-red-700",
    info: "text-blue-700",
  };
  return (
    <div className="stat-card" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 font-bold">
            {label}
          </div>
          <div className={`font-display text-3xl font-black tracking-tighter mt-2 tabular-nums ${tones[tone]}`}>
            {value}
          </div>
          {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
        </div>
        {Icon && (
          <div className="w-9 h-9 bg-slate-100 flex items-center justify-center rounded-sm">
            <Icon size={18} weight="bold" className="text-slate-700" />
          </div>
        )}
      </div>
    </div>
  );
}

export function Badge({ tone = "neutral", children, testid }) {
  return (
    <span className={`badge badge-${tone}`} data-testid={testid}>
      {children}
    </span>
  );
}

export function statusBadge(status) {
  const map = {
    active: { tone: "success", label: "Active" },
    maintenance: { tone: "warning", label: "In Maintenance" },
    retired: { tone: "neutral", label: "Retired" },
    completed: { tone: "success", label: "Completed" },
    in_progress: { tone: "info", label: "In Progress" },
    scheduled: { tone: "info", label: "Scheduled" },
    upcoming: { tone: "info", label: "Upcoming" },
    overdue: { tone: "danger", label: "Overdue" },
  };
  return map[status] || { tone: "neutral", label: status };
}

export function urgencyBadge(urg) {
  const map = {
    danger: { tone: "danger", label: "OVERDUE" },
    warning: { tone: "warning", label: "DUE SOON" },
    info: { tone: "info", label: "UPCOMING" },
  };
  return map[urg] || { tone: "neutral", label: urg };
}
